export function ColumnResizeComponent() {
  return {
    restrict  : 'A',
    link: function (scope, element, attrs) {
      let handleContainer = angular.element('<div class=\'rc-handle-container\' />');
      element.before(handleContainer);
      let drag = false;
      let colClassPattern = 'rc-';
      let scrollbarWidth = 15;
      let colPadding = 11;
      let tableContentWidth = 0;
      let thSelector = 'tr th:visible';
      let viewMode = null;
      let tableColumns;
      let initViewMode = function () {
        if (!viewMode) {
          return;
        }
        let tableWidth = element.width();
        // take stock of scrollbar and borders
        tableContentWidth = tableWidth - scrollbarWidth - viewMode.columns.length * colPadding;
        element.find('.fact-table-thead').width(tableWidth - scrollbarWidth);
        initColumnWidths();
      };
      let initHandlers = function () {
        //console.log('initHandlers');
        tableColumns = element.find(thSelector);
        element.find('.rc-handle').remove();
        tableColumns.each(function (index) {
          if (index + 1 === tableColumns.length) {
            return;
          }
          let handle = angular.element('<div class=\'rc-handle\' />');
          handle.data('rc-id', index);
          handle.data('leftCol', this);
          handle.appendTo(handleContainer);
        });
      };
      let syncHandlers = function () {
        //console.log('syncHandlers');
        let height = element.height();
        handleContainer.find('.rc-handle').each(function () {
          const handler = angular.element(this);
          let column = angular.element(handler.data('leftCol'));
          let left = column.outerWidth() + (column
              .offset().left - handleContainer.offset().left);
          handler.css({left: left, height: height});
        });
      };
      let initColumnWidths = function () {
        if (!viewMode) return;
        // Set column width
        viewMode.colwidths.forEach((colwidth, i) => {
          element.find('.' + colClassPattern + i.toString()).width(Math.floor(colwidth * tableContentWidth));
        });
      };

      scope.$on('factsLoaded', function () {
        //console.log('Caught factsLoaded..');
        initViewMode();
        syncHandlers();
      });
      scope.$on('splitterChanged', function () {
        //console.log('splitterChanged');
        initViewMode();
        syncHandlers();
      });
      scope.$on('viewModeChanged', function (e, vm) {
        //console.log('viewModeChanged '+vm.name);
        if (vm.colwidths == undefined) {
          vm.colwidths = vm.columns.map(function (col) {
            return 1 / vm.columns.length;
          });
        } else {
          vm.colwidths[vm.colwidths.length - 1] = 1 - vm.colwidths.reduce(
              function (p, c, i, a) {
                return i !== a.length - 1 ? p + c : p;
              },
              0,
            );
        }
        viewMode = vm;
        initViewMode();
        initHandlers();
        syncHandlers();
      });
      let startPosition;
      let currentGrip;
      let currentGripPosition;
      let leftColumn;
      let leftColumnWidth;
      let rightColProps = [];
      let leftGroupWidth = 0;
      let pointerdown = e => {
        startPosition = e.pageX;
        //console.log("start: " + startPosition);
        e.preventDefault();
        drag = true;

        currentGrip = angular.element(e.currentTarget);
        currentGripPosition = currentGrip.position().left;

        let id = currentGrip.data('rc-id');

        leftColumn = element.find('.' + colClassPattern + id.toString());
        leftColumnWidth = leftColumn.width();

        // Calculate left block width
        leftGroupWidth = 0;
        for (let i = 0; i <= id; i++) {
          let column = element.find('.' + colClassPattern + i);
          leftGroupWidth += column.width();
          //console.log("id=" + i + ", w=" + column.width());
        }
        let rightGroupWidth = tableContentWidth - leftGroupWidth;
        for (let i = id + 1; i < viewMode.colwidths.length; i++) {
          rightColProps[i] = rightGroupWidth ? viewMode.colwidths[i] / (rightGroupWidth / tableContentWidth) : 0;
          //console.log("rightColProps[" + i + "]=" + rightColProps[i]);
        }
        //console.log("leftGroupWidth: " + leftGroupWidth);
      };
      let pointerup = e => {
        if (!drag) {
          return;
        }
        e.preventDefault();
        drag = false;

        if (viewMode) {
          for (let i = 0; i < viewMode.colwidths.length; i++) {
            viewMode.colwidths[i] = element.find('.' + colClassPattern + i)
                .width() / tableContentWidth;
          }
        }
        //__logProportionsSum();

        rightColProps = [];
        syncHandlers();
      };
      let pointermove = e => {
        if (!drag) {
          return;
        }
        e.preventDefault();

        let delta = e.pageX - startPosition;

        if (leftColumnWidth + delta < 0) {
          delta = -leftColumnWidth;
        }
        if (tableContentWidth - (leftGroupWidth + delta) < 0) {
          delta = tableContentWidth - leftGroupWidth;
        }

        //console.log("new leftGroupWidth: " + (leftGroupWidth + delta) + ", delta: " + delta);
        if (viewMode) {
          currentGrip.css({left: currentGripPosition + delta});
          leftColumn.width(Math.floor(leftColumnWidth + delta));

          let id = currentGrip.data('rc-id');

          viewMode.colwidths[id] = (leftColumnWidth + delta) / tableContentWidth;

          let rightColumnWidth;
          if (_isAllRightColumnsZero(id, rightColProps)) {
            rightColumnWidth = (tableContentWidth - (leftGroupWidth + delta));
            element.find('.' + colClassPattern + (id + 1)).width(rightColumnWidth);
            //console.log("all rights zero w[" + (id + 1) + "]=" + rightColumnWidth);
          } else {
            for (let i = id + 1; i < viewMode.colwidths.length; i++) {
              rightColumnWidth = rightColProps[i] * (tableContentWidth - (leftGroupWidth + delta));
              if (rightColumnWidth < 0) {
                rightColumnWidth = 0;
              }
              element.find('.' + colClassPattern + i).width(Math.floor(rightColumnWidth));
              //console.log("w[" + i + "]=" + rightColumnWidth + ", prop=" + rightColProps[i]);
            }
          }

          //__logRealColumnWidths();
        }
      };

      let _isAllRightColumnsZero = function (id, rightColProps) {
        for (let i = id + 1; i < rightColProps.length; i++) {
          if (rightColProps[i] != 0) {
            return false;
          }
        }
        return true;
      };

      let __logProportionsSum = function () {
        let reduce = viewMode.colwidths.reduce(function (
          previousValue,
          currentValue,
          currentIndex,
          array,
        ) {
          return previousValue + currentValue;
        });
        console.log('__logProportionsSum: ' + reduce);
        return reduce;
      };

      let __logRealColumnWidths = function () {
        let logText = '';
        for (let i = 0; i < viewMode.colwidths.length; i++) {
          let w = element.find('.' + colClassPattern + i).width();
          logText += 'w[' + i + ']=' + w + '  |  ';
        }
        console.log('__logRealColumnWidths: ' + logText + 'table=' + tableContentWidth);
      };

      handleContainer.on('mousedown', '.rc-handle', pointerdown);

      document.addEventListener('mouseup', pointerup);
      document.addEventListener('mousemove', pointermove);
      scope.$on('$destroy', () => {
        document.removeEventListener('mouseup', pointerup);
        document.removeEventListener('mousemove', pointermove);
      });
    },
  };
}




// WEBPACK FOOTER //
// ./src/facts/colresize.js